import React, { PureComponent } from 'react';

import config from './AmountInputPredefined.config';

import { formatNumber, parseNumber } from '../utils';
import { MIN_AMOUNT, MAX_AMOUNT } from '../../constant';
import iconClose from '../../assets/close.svg';
import './AmountInputPredefined.less';

class AmountInputPredefined extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFocus: false,
      // To check invalid input after user input valid value
      isEverValid: false,
      currentValue: '0',
      prevValue: '0',
    };
  }

  _onFocus = () => {
    this.setState({ isFocus: true });
  };

  _onBlur = () => {
    this.setState({ isFocus: false });
  };

  _forceUpdateState = value => {
    this.setState({ currentValue: formatNumber(value) });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue !== this.state.currentValue) {
      this.props.input.onChange(parseNumber(this.state.currentValue));
    }
    if (prevProps.input.value !== this.props.input.value) {
      this._forceUpdateState(this.props.input.value);
    }
  }

  _onChange = event => {
    event.persist();
    const inputValue = event.target.value;
    const caretStart = event.target.selectionStart;

    const val = parseNumber(inputValue);
    let result;
    if (val <= 0) {
      result = 0;
    } else if (val > MAX_AMOUNT) {
      result = MAX_AMOUNT;
    } else {
      result = val;
    }

    const { length } = result.toString();
    const { length: valLength } = val.toString();

    this.setState(
      prevState => {
        let currentValue = result;

        if (parseNumber(prevState.currentValue) === 0) {
          if (length > caretStart) {
            currentValue /= 10;
          }
          if (valLength === 8 && val % 10 === 0) {
            currentValue = val / 10;
          }
        }
        return {
          currentValue: formatNumber(currentValue),
          prevValue: prevState.currentValue,
          ...(this._isValidInput(currentValue) && { isEverValid: true }),
        };
      },
      () => {
        const { prevValue, currentValue } = this.state;

        const { length: currentLength } = currentValue;
        const { length: prevLength } = prevValue;

        let caretPos;

        if (currentLength === prevLength) {
          caretPos = caretStart;
        } else if (currentLength > prevLength) {
          caretPos = currentLength - prevLength + caretStart - 1;
        } else if (prevLength - currentLength === 2) {
          caretPos = caretStart - 1 >= 0 ? caretStart - 1 : 0;
        } else {
          caretPos = caretStart;
        }
        event.target.setSelectionRange(caretPos, caretPos);
      },
    );
  };

  _isValidInput = input => input >= MIN_AMOUNT;

  _onClose = () => {
    document.getElementById('inputAmount').blur();
    this.setState(prevState => ({
      prevValue: prevState.currentValue,
      currentValue: '0',
    }));
  };

  _onClickBtn = value => () => {
    const currency = formatNumber(value);

    this.setState(
      prevState => ({
        prevValue: prevState.currentValue,
        currentValue: currency,
        isFocus: true,
        ...(this._isValidInput(value) && { isEverValid: true }),
      }),
      () => {
        this.inputAmount.focus();
      },
    );
  };

  _renderDefinedValue = (value, listValue) => {
    const amount = Math.floor(value).toString();
    const totalValue = parseInt(amount, 10);
    const more1K = totalValue >= 1000 ? Math.floor(totalValue / 1000) : null;
    const { length } = amount;
    const typed = this.props.input.value;
    let predefinedActive = false;
    // Check Predefine by all listed value
    for (let i = 0; i <= listValue.length; i += 1) {
      const amountValue = parseInt(Math.floor(listValue[i]).toString(), 10);
      // The condition when only exact same value and same typed
      if (amountValue === typed && totalValue === typed) {
        predefinedActive = true;
        break;
      }
    }

    return (
      <button
        onClick={this._onClickBtn(amount)}
        type="button"
        className={`${predefinedActive ? 'active' : ''}`}
      >
        {more1K && more1K.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
        {
          <span>{`${amount[length - 3] || ''}${amount[length - 2] ||
            ''}${amount[length - 1] || ''}`}</span>
        }
      </button>
    );
  };

  _setRef = input => {
    this.inputAmount = input;
  };

  render() {
    const {
      label,
      hint,
      intl: { formatMessage },
      'predefined Value 1': defVal1,
      'predefined Value 2': defVal2,
      'predefined Value 3': defVal3,
      'predefined Value 4': defVal4,
      meta: { error, pristine, touched },
    } = this.props;

    const { isEverValid, currentValue, isFocus } = this.state;

    let errorMsg = '';
    const errorType = (error || '').split('.')[1];
    let inputState = '';
    if (
      (errorType === 'min' && (touched || isEverValid)) ||
      (errorType === 'max' && !pristine)
    ) {
      inputState = 'error';
      errorMsg = error;
    } else if (isFocus) {
      inputState = 'active';
    }

    const errAmount = errorType === 'min' ? `${MIN_AMOUNT}` : `${MAX_AMOUNT}`;
    const buildListValue = [defVal1, defVal2, defVal3, defVal4];

    const emptyState = currentValue === '0' ? 'empty' : '';

    return (
      <div className="AmountInputPredefined">
        <div className="AmountInput">
          <div className="input-wrapper">
            <span
              className={`semi-bold ${inputState}`}
              id="text_labelInputAmount"
            >
              {label}
            </span>
            <div className={`input-field ${inputState}`}>
              <span className={`currency ${emptyState}`}>Rp</span>
              <input
                className={`input-amount ${emptyState}`}
                ref={this._setRef}
                id="inputAmount"
                type="text"
                inputMode="tel"
                autoComplete="off"
                value={currentValue}
                placeholder={0}
                maxLength="10"
                onFocus={this._onFocus}
                onBlur={this._onBlur}
                onChange={this._onChange}
              />
              {currentValue && currentValue !== '0' && (
                <div onClick={this._onClose} id="btn_closeInputAmount">
                  <img src={iconClose} alt="" />
                </div>
              )}
            </div>
            <span id="text_hintInputAmount" className={inputState}>
              {inputState === 'error'
                ? formatMessage({ id: errorMsg }) + errAmount
                : hint}
            </span>
          </div>
        </div>
        <div className="defineAmount">
          <div className="rowBtn">
            {this._renderDefinedValue(defVal1, buildListValue)}
            {this._renderDefinedValue(defVal2, buildListValue)}
          </div>
          <div className="rowBtn">
            {this._renderDefinedValue(defVal3, buildListValue)}
            {this._renderDefinedValue(defVal4, buildListValue)}
          </div>
        </div>
      </div>
    );
  }
}

AmountInputPredefined.propTypes = config.propTypes;
AmountInputPredefined.defaultProps = config.defaultProps;
AmountInputPredefined.componentDetail = config.componentDetail;
AmountInputPredefined.builderConfig = config.builderConfig;

export default AmountInputPredefined;
